import React, { Component } from "react";
import {
  BrowserRouter as Router,
  Switch,
  HashRouter,
  Route,
  BrowserRouter,
  Redirect,
} from "react-router-dom";

import Popup from "./components/common/Popup";
import Home from "./components/Home";
import Loading from "./components/common/Loading";
import Bmw from "./components/Bmw";
import Model from "./components/Model";
import Customer from "./components/Customer";
import Document from "./components/Document";
import Info from "./components/Info";
import Selfie from "./components/Selfie";
import SelfieInfo from "./components/SelfieInfo";
import Order from "./components/Order";
import * as GetPixelAPI from "./apis/GetPixelAPI";
import * as FacebookAPI from "./apis/FacebookAPI";
import queryString from "query-string";
import Success from "./components/Success";
import Fail from "./components/Fail";
import Share from "./components/Share";
import Contact from "./components/Contact";
import { url } from "./constants/ApiEndpointConstants";
import Cart from "./components/Cart";
import Proof from "./components/Proof";
import ProofInfo from "./components/ProofInfo";
import LocalStorageUtil from "./utils/LocalStorageUtil";
import { generateRandomString } from "./utils/RandomGeneratorUtils";
import safeParse from "./utils/SafeParseLocalstrorage";
import "./index.css";
import { getLanguage } from "./utils/lang";
import PagePath from "./constants/router/PagePath";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      language: getLanguage(),
    };
  }

  componentDidMount() {
    document.documentElement.lang = this.state.language || "en";
    window.addEventListener("languagechange", this.handleLanguageChange);
    //根据uuid 设置匿名用户id，用于广告事件event_id 去重
    const cachedAnonymousUserId = LocalStorageUtil.loadAnonymousUserId();
    if (!cachedAnonymousUserId) {
      const anonymousUserId = generateRandomString(10);
      LocalStorageUtil.saveAnonymousUserId(anonymousUserId);
    }
  }

  componentWillUnmount() {
    window.removeEventListener("languagechange", this.handleLanguageChange);
  }

  isMobileDevice() {
    // 检测 userAgent 字符串中的移动设备标识
    const userAgent = navigator.userAgent;
    return /Mobi|Android|iPhone|iPad|iPod|BlackBerry|Windows Phone/i.test(
      userAgent,
    );
  }

  render() {
    return (
      <BrowserRouter>
        <React.Fragment>
          <Popup {...this.props} />
          <Switch>
            <Route path="/proofInfo" component={ProofInfo}></Route>
            <Route path="/proof" component={Proof}></Route>
            <Route path="/Cart" component={Cart}></Route>
            <Route path="/Contact" component={Contact}></Route>
            <Route path="/fail" component={Fail}></Route>
            <Route path="/success" component={Success}></Route>
            <Route path="/Information" component={Order}></Route>
            <Route path="/SelfieInfo" component={SelfieInfo}></Route>
            <Route path="/Selfie" component={Selfie}></Route>
            <Route path="/Info" component={Info}></Route>
            <Route path="/Document" component={Document}></Route>
            <Route
              path={PagePath.CUSTOMER}
              render={(routeProps) => <Customer {...routeProps} />}
            />
            <Route path={PagePath.MODEL} component={Model}></Route>
            <Route path={PagePath.TESLA} component={Bmw}></Route>
            {/* <Route path={PagePath.SHARE} component={Share}></Route> */}
            {/* <Route exact path={PagePath.HOME}>
              <Redirect to={PagePath.MODEL} />
            </Route> */}
            <Route
              path={PagePath.HOME}
              render={(routeProps) => <Home {...routeProps} />}
            />
          </Switch>
        </React.Fragment>
      </BrowserRouter>
    );
  }
}
export default App;
